import { render, staticRenderFns } from "./authorizeManagementList.vue?vue&type=template&id=6119137c"
import script from "./authorizeManagementList.vue?vue&type=script&lang=js"
export * from "./authorizeManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports